<template>
    <default-item class="chi_default_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout" tag-location="after-title"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for CHI food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.3
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-07-20 (1.0.0) (jhoward)
 *      - <panchoWilliesFoodItem> copied to <chi-default-item>.
 *
 *    2023-10-05 (1.0.1) (jhoward)
 *      - <chi-default-item> displays tags after the menu item title.
 *
 *    2024-07-19 (1.0.2) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <chi-default-item>.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <chi-default--item>.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'chi-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: ''
    }
  },
})
</script>

<style scoped>
.visual_menu--section .chi_default_item--container:not(.menu--item-no_price) {
  grid-template-columns: 1fr 0.5fr;
}

.chi_default_item--container:deep(.menu--tag) {
  position: relative;
  right: auto;
  top: auto;
  margin-left: auto;
}

.chi_default_item--container:deep(.menu--tag.tag-gluten-free),
.chi_default_item--container:deep(.menu--tag.tag-raw_or_undercooked),
.chi_default_item--container:deep(.menu--tag.tag-hot_and_spicy) {
  display: initial;
}
</style>